import { styled } from '@mui/material/styles';

export const ReasonContainer = styled('span')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '4px',
  width: '100%',
}));

export const ReasonText = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})<{ isExpanded: boolean }>(({ isExpanded }) => ({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: isExpanded ? 'normal' : 'nowrap',
  overflowWrap: 'break-word',
}));

export const ExpandButton = styled('button')(({ theme }) => ({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  color: theme.palette.primary.main,
  cursor: 'pointer',
  display: 'flex',
  padding: 0,

  '& span': {
    fontSize: '20px',
  },
}));
